import type { ReactNode } from 'react'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export interface SeoCardProps {
  score: number
  title: string
  description: string
  keywords: string[]
}

export const SeoCard: React.FC<SeoCardProps> = ({
  score,
  title,
  description,
  keywords,
}): ReactNode => (
  <Card className="seo-info-card">
    <CardHeader className="pb-3">
      <CardTitle className="flex items-center justify-between text-base">
        <span>SEO Analysis</span>
        <Badge variant={score >= 80 ? 'default' : 'secondary'}>Score: {score}/100</Badge>
      </CardTitle>
    </CardHeader>
    <CardContent className="grid gap-3 text-sm">
      <div className="flex flex-col gap-1">
        <span className="text-muted-foreground">Title</span>
        <span className="font-medium">{title}</span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-muted-foreground">Description</span>
        <span className="text-muted-foreground/80">{description}</span>
      </div>
      <div className="flex flex-col gap-1.5">
        <span className="text-muted-foreground">Keywords</span>
        <div className="flex flex-wrap gap-1">
          {keywords.map((keyword) => (
            <Badge key={keyword} variant="secondary" className="text-xs">
              {keyword}
            </Badge>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
)
